import { ComponentUserMenuVO } from '@repo/types'
import { Dropdown, DropdownActionProps, useKeycloak, useNotificationSound } from '@web/modules/core'
import React, { useEffect, useState } from 'react'
import { RightComponentButton } from '.'
import { useNavigate } from 'react-router'
import { useUserInfo } from '@repo/core'
import { Avatar, Toggle, Tooltip, useSnackbar } from '@tecsinapse/cortex-react'
import { BsQuestionCircle } from 'react-icons/bs'
import { PiCellSignalSlashBold } from 'react-icons/pi'
import { MdOpenInNew, MdOutlineSchool, MdVolumeOff, MdVolumeUp } from 'react-icons/md'
import { AiOutlineQuestionCircle } from 'react-icons/ai'
import { useStomp } from '@repo/network'

interface RightComponentProps {
  userMenu: ComponentUserMenuVO
}

const RightComponent = ({ userMenu }: RightComponentProps) => {
  const { connected } = useStomp()
  const { soundEnabled, changeSound, changeSoundStorage } = useNotificationSound()
  const { instance: kcInstance } = useKeycloak()
  const { userInfo, changingUserAvailable, requestChangeUserAvailable } = useUserInfo()
  const { snackbar } = useSnackbar()
  const navigate = useNavigate()

  const [showConnectionMessage, setShowConnectionMessage] = useState(false)
  const [openAccount, setOpenAccount] = useState(false)

  const dropdownActions: DropdownActionProps[] = []

  if (userMenu.accountUrl) {
    dropdownActions.push({
      label: 'Minha Conta',
      onClick: () => {
        if (userMenu.accountUrl) {
          window.open(userMenu.accountUrl, '_blank')
        }
      }
    })
  }

  if (kcInstance) {
    dropdownActions.push({
      label: 'Sair',
      onClick: () => {
        navigate('/logout', { replace: true })
      }
    })
  }

  useEffect(() => {
    if (!connected) {
      const timer = setTimeout(() => {
        setShowConnectionMessage(true)
      }, 5000)
      return () => clearTimeout(timer)
    } else {
      setShowConnectionMessage(false)
    }
  }, [connected])

  useEffect(() => {
    window.onstorage = changeSoundStorage
  }, [changeSoundStorage])

  const handleOpenUrl = (url: string) => () => {
    window.open(url, '_blank')
  }

  const handleRequestChangeUserAvailable = (value: boolean) => {
    requestChangeUserAvailable(value, {
      onError: () =>
        snackbar.show('error', 'A operação não pôde ser concluída.\nAguarde alguns minutos e tente novamente.')
    })
  }

  return (
    <div className='flex items-center z-[701]'>
      {showConnectionMessage && (
        <div className='flex flex-row space-x-mili text-secondary-medium'>
          <PiCellSignalSlashBold />
          <p>O Wingo Chat está tentando se conectar</p>
        </div>
      )}
      {userInfo?.showAvailable && (
        <div className='flex flex-row items-center space-x-mili mx-mega'>
          <Toggle
            onChange={e => handleRequestChangeUserAvailable(e.target.checked)}
            disabled={changingUserAvailable}
            checked={userInfo?.available}
          />
          <label>{userInfo?.available ? 'Usuário disponível' : 'Usuário indisponível'}</label>
          <div>
            <Tooltip text='Se desligado, não será possível receber novas conversas'>
              <div className='flex text-centi'>
                <BsQuestionCircle />
              </div>
            </Tooltip>
          </div>
        </div>
      )}
      <RightComponentButton
        title='Ativar/Desativar Som'
        icon={soundEnabled ? <MdVolumeUp /> : <MdVolumeOff />}
        onClick={changeSound}
      />
      {userMenu.academyUrl && (
        <RightComponentButton
          title='Acessar Academia'
          icon={<MdOutlineSchool />}
          onClick={handleOpenUrl(userMenu.academyUrl)}
        />
      )}
      {userMenu.helptecUrl && (
        <RightComponentButton
          title='Acessar Helptec'
          icon={<AiOutlineQuestionCircle />}
          onClick={handleOpenUrl(userMenu.helptecUrl)}
        />
      )}
      {userMenu.portalUrl && (
        <RightComponentButton
          title='Acessar Portal'
          icon={<MdOpenInNew />}
          onClick={handleOpenUrl(userMenu.portalUrl)}
        />
      )}
      <div className='ml-4'>
        <Dropdown
          controlled={true}
          isOpen={openAccount}
          setIsOpen={setOpenAccount}
          title={userMenu.userName}
          actions={dropdownActions}
          trigger={<Avatar name={userMenu.userName} />}
        />
      </div>
    </div>
  )
}

export default RightComponent
